// extracted by mini-css-extract-plugin
export default {"wrapper":"iDDa5__wrapper","key":"PEuCW__key j7jo7__sectionHeader","value":"QUYKA__value"};